import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]

  connect() {
    // Initialize accordions to be closed by default
    this.contentTargets.forEach(content => {
      content.style.display = "none";
    });
  }

  toggle(event) {
    const accordion = event.currentTarget;
    accordion.classList.toggle("active");

    // Find the closest content target (the panel)
    const content = accordion.nextElementSibling;
    const icon = accordion.querySelector(".accordion-icon");

    // Toggle icon rotation
    if (icon.style.transform === "rotate(180deg)") {
      icon.style.transform = "rotate(0deg)";
    } else {
      icon.style.transform = "rotate(180deg)";
    }

    // Toggle the panel
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
  }
}